export const LivenessImageMovementPayloadValues = Object.freeze({
    LEFT: 'left',
    RIGHT: 'right',
    UP: 'up',
    DOWN: 'down',
    SMILE: 'smile',
    RIGHTBLINK: 'rightblink',
    LEFTBLINK: 'leftblink',
    MATCH: 'match',
});